{
  "name": "@residently/embed-sdk",
  "version": "0.0.1-rc.0",
  "description": "Embed Residently listing collections and detail views within your website",
  "keywords": [
    "Residently",
    "Embed"
  ],
  "scripts": {
    "test:lint": "eslint .",
    "test:types": "tsc",
    "test": "npm --test",
    "build": "node ./esbuild.mjs",
    "publish": "clean-publish"
  },
  "main": "dist/index.cjs.js",
  "module": "dist/index.esm.js",
  "types": "dist/index.d.ts",
  "author": "Rob Aldred",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/residently/embed-sdk"
  },
  "engines": {
    "node": "^18.0.0 || >=20.0.0"
  },
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": "./src/index.js",
    "./types": "./dist/types.js"
  },
  "files": [
    "dist/"
  ],
  "publishConfig": {
    "main": "./dist/index.cjs",
    "module": "./dist/index.js",
    "directory": "package"
  },
  "devDependencies": {
    "@types/node": "^22.7.5",
    "clean-publish": "^5.0.0",
    "esbuild": "^0.25.0",
    "eslint": "^9.12.0",
    "tsx": "^4.19.1",
    "typescript": "^5.6.3"
  },
  "prettier": {
    "arrowParens": "avoid",
    "jsxSingleQuote": false,
    "quoteProps": "consistent",
    "semi": false,
    "singleQuote": true,
    "trailingComma": "none"
  },
  "clean-publish": {
    "cleanDocs": true
  }
}
